"use client";

import { useState } from "react";

import { Title } from "@/components/Title";
import ImageContainer, {
    ImageContainerProps,
} from "@/components/ImageContainer";
import { Modal } from "../Modal";

interface ProfileHeaderProps {
    title: string;
    titleClassName?: string;
    titleElement?: React.ReactNode;
    subtitle?: string;
    image: File | string | null;
    imageProps: Omit<ImageContainerProps, "image">;
    children?: React.ReactNode;
}

export default function ProfileHeader({
    title,
    titleClassName,
    titleElement,
    subtitle,
    image,
    imageProps,
    children,
}: ProfileHeaderProps) {
    const [showImageModal, setShowImageModal] = useState(false);
    const size = imageProps.size * 4;

    return (
        <>
            <Title className={`!gap-0 pb-2`}>
                <div
                    className={`flex flex-row gap-4 items-center ${titleClassName}`}
                >
                    <ImageContainer
                        image={image}
                        {...imageProps}
                        onClick={() => setShowImageModal(true)}
                    />
                    <div className="flex-1 flex flex-col gap-0">
                        <h1 className="!mb-0">{title}</h1>
                        {subtitle && <h4>{subtitle}</h4>}
                    </div>
                    {titleElement}
                </div>
                {children}
            </Title>

            {showImageModal && (
                <Modal
                    title={title}
                    variant="popup"
                    onClose={() => setShowImageModal(false)}
                    style={{
                        minWidth: `unset`,
                    }}
                >
                    <ImageContainer
                        image={image}
                        {...{ ...imageProps, size }}
                    />
                </Modal>
            )}
        </>
    );
}
